import { Ring } from "@uiball/loaders";
import PropTypes from "prop-types";

import { withTooltip } from "../../hoc";

import SVG from "../SVG/icons";
import CircleIconButton from "./CircleIconButton";
import WrapperContainer from "../Containers/WrapperContainer";
import FlexContainers from "../Containers/FlexContainers";
import { t } from "../../services";
import { strCode } from "../../consts";
import IconButton from "./IconButton";

const EditButtonsGroup = ({
  handleCancel = () => {},
  handleAccept = () => {},
  handleEdit = () => {},
  isEdit = true,
  isLoading,
  disableAccept = false,
  disableCancel = false,
  disableEdit = false
}) => {
  return isEdit ? (
    <IconButton
      hasHoverCircle
      isLarge
      tooltipLabel={t(strCode.EDIT)}
      onClick={handleEdit}
      disabled={disableEdit || isLoading}>
      <SVG.EditAppIcon />
    </IconButton>
  ) : isLoading ? (
    <WrapperContainer Container={FlexContainers.FlexColumnCenter} height={48} width={48}>
      <Ring size={18} lineWeight={5} speed={2} />
    </WrapperContainer>
  ) : (
    <WrapperContainer
      Container={FlexContainers.FlexRow}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      gap={8}>
      <CircleIconButton disabled={disableCancel} secondary={true} onClick={handleCancel}>
        <SVG.AcceptBtnIcon />
      </CircleIconButton>
      <CircleIconButton disabled={disableAccept} onClick={handleAccept}>
        <SVG.DeclineBtnIcon />
      </CircleIconButton>
    </WrapperContainer>
  );
};

EditButtonsGroup.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleAccept: PropTypes.func.isRequired,
  handleEdit: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  disableAccept: PropTypes.bool,
  disableCancel: PropTypes.bool,
  disableEdit: PropTypes.bool
};

export default withTooltip(EditButtonsGroup);
